"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { RelativeTimeSuffix } from "@/components/domain/relative-time-suffix";
import { useHydratedNow } from "@/hooks/use-hydrated-now";
import { formatRelativeTime, toDateTimeAttr } from "@domainstack/utils/date";
export function RelativeAgeString(t0) {
  const $ = _c(9);
  const {
    from,
    className
  } = t0;
  const now = useHydratedNow();
  let t1;
  if ($[0] !== from) {
    t1 = toDateTimeAttr(from);
    $[0] = from;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const dateTime = t1;
  let t2;
  bb0: {
    if (!now || !dateTime) {
      t2 = null;
      break bb0;
    }
    let t3;
    if ($[2] !== dateTime || $[3] !== now) {
      t3 = formatRelativeTime(new Date(dateTime), now) ?? null;
      $[2] = dateTime;
      $[3] = now;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = t3;
  }
  const text = t2;
  let t3;
  if ($[5] !== className || $[6] !== dateTime || $[7] !== text) {
    t3 = <RelativeTimeSuffix dateTime={dateTime} text={text} className={className} />;
    $[5] = className;
    $[6] = dateTime;
    $[7] = text;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}